import React from "react";
import FormPage from "../../components/forms/FormPage";
import FormEntitySelectionField from "../../components/forms/fields/basic/EntitySelectionField";
import FormSelectField from "../../components/forms/fields/basic/SelectField";
import { Work } from "../../types/work";
import renderWorkSelection from "../../components/entitiesReferences/SelectionModals/WorkSelectionModal";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { SystemLanguages } from "../../shared/enums/shared-enums";
import FormTextField from "../../components/forms/fields/basic/TextField";
import useWorkLogic from "../../hooks/logic/workLogic";
import useWorkController from "../../controllers/workController";

interface AddEditWorkFormProps {
  _id: string | null;
  systemLanguageType: Work["system_language_type"];
  sections?: (work: Work) => React.ReactElement[];
}

const AddEditWorkForm: React.FC<AddEditWorkFormProps> = ({
  _id,
  systemLanguageType,
  sections,
}) => {
  const controller = useWorkController(_id, systemLanguageType);
  const formController = { ...controller, title: controller.editTitle };
  const workLogic = useWorkLogic(systemLanguageType);

  return (
    <FormPage<Work> controller={formController} sections={sections}>
      <FormTextField name="name" label="Name" placeholder="Name" />
      {workLogic.showField("availability") && (
        <FormSelectField
          name="availability"
          label="Availability"
          useEnum={workLogic.availabilityEnum}
          placeholder="Select Availability"
        />
      )}
      {workLogic.showField("keywords") && (
        <FormSelectField
          name="keywords"
          label="Keywords"
          useEnum={workLogic.keywordsEnum}
          multiple
          placeholder="Select Language"
        />
      )}
      {workLogic.showField("work_origin") && (
        <FormSelectField
          name="work_origin"
          label="Origin"
          useEnum={workLogic.workOriginEnum}
          multiple
          placeholder="Select Origin"
        />
      )}
      {workLogic.showField("translation_of_indic_work") && (
        <FormEntitySelectionField
          name="translation_of_indic_work"
          label="Translation of Work"
          placeholder="Select Indic Work"
          entityCollection={SystemEntityCollections.WORK}
          renderEntitySelection={renderWorkSelection(SystemLanguages.indic)}
        />
      )}
      {workLogic.showField("compositional_form") && (
        <FormSelectField
          name="compositional_form"
          label="Compositional Form"
          useEnum={workLogic.compositionalFormEnum}
          placeholder="Select Compositional Form"
        />
      )}
    </FormPage>
  );
};

export default AddEditWorkForm;
